import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CancelBookingIndex } from '@/pages/self-booking-public-widget/CancelBookingIndex';

const searchSchema = z.object({
	bookingId: z.string().optional(),
	canceled: z.coerce.string().optional(),
});

export const Route = createFileRoute('/cancel-booking/$slug')({
	validateSearch: searchSchema,
	component: CancelBookingIndex,
});
